import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const treatmentPlanChartContainerStyle = css`
  display: flex;
  gap: ${theme.spacing(0.5)};
  justify-content: space-between;

  @container (min-width: 470px) {
    gap: ${theme.spacing(2)};
  }

  > div {
    overflow: hidden;
  }
`;
